// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__GZcwO","text":"style_text__6VFvc"};